import React, { useState, useEffect, useRef } from "react";
import "../Main_Page/profile.css"; // Add styles for the component
import { useHistory } from "react-router-dom";

import AdminUpdatePasswordModal from "../Models/changePassword";
import { BASE_URL } from "../../App_Settings/app_settings";
import ExitToAppIcon from "@mui/icons-material/ExitToApp"; // Icon for logout
import { getUserIdFromLocalStorage } from "../../API_Endpoints/APIEndpoints";

const ProfileDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [firstTwoCharacters, setFirstTwoCharacters] = useState("");
  const [organizationName, setOrganizationName] = useState(null);
  const [showResetPopup, setShowResetPopup] = useState(false);
  const dropdownRef = useRef(null); // Ref for dropdown
  const popupRef = useRef(null); // Ref for reset popup
  const history = useHistory();
  const [editingData, setEditingData] = React.useState(null);

  const openResetPopup = () => {
    setShowResetPopup(true);
  };

  const closeResetPopup = () => {
    setShowResetPopup(false);
  };

  useEffect(() => {
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);
      const firstLetterOfFirstName = userData.firstName.charAt(0).toUpperCase();
      const firstLetterOfLastName = userData.lastName.charAt(0).toUpperCase();
      setFirstTwoCharacters(firstLetterOfFirstName + firstLetterOfLastName);
      setUserName(userData.firstName + " " + userData.lastName);
      setUserEmail(userData.userName);
      setEditingData(userData.userName);
      setOrganizationName(userData.organizationName);

      // Make sure 'email' property exists in your data.
    }
  });

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  // Handle clicks outside dropdown or popup
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
        //  &&
        // popupRef.current &&
        // !popupRef.current.contains(event.target)
      ) {
        setIsOpen(false);
        // setShowResetPopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleLogout = async () => {
    // Terminate session on server
    const sessionToken = localStorage.getItem("sessionToken");
    const tokenData = localStorage.getItem("token");
    if (sessionToken && tokenData) {
      try {
        const userData = JSON.parse(tokenData);
        await fetch(`${BASE_URL}/api/SessionManagement/logout-all`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "X-Session-Token": sessionToken,
          },
        });
      } catch (error) {
        console.error("Session logout error:", error);
      }
    }
    localStorage.removeItem("token");
    localStorage.removeItem("sessionToken");
    localStorage.removeItem("CopilotToken");
    history.replace("/login");
  };
  const handleSavePassword = (data) => {
    const userDataJSON = localStorage.getItem("token");
    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);
      //api calls to post the data
      return fetch(`${BASE_URL}/users/changepassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
        body: JSON.stringify({
          userId: userData.userId,
          organizationId: userData.organizationId,
          newPassword: data.password,
        }),
      })
        .then((response) => {
          if (response.ok) {
            return response.json(); // Parse JSON if response is OK
          } else {
            alert(`Request failed with status ${response.status}`);
            throw new Error(`Request failed with status ${response.status}`); // Handle non-200 status codes
          }
        })
        .then((data) => {
          if (data) {
            alert("The password has been updated successfully!");
            closeResetPopup();
          }
        });
    } else {
      alert(
        "There seems to be an issue with the change password feature. Could you please log out, log back in, and try again?"
      );
    }
  };

  return (
    <div className="profile-container">
      {/* Profile Icon */}
      <div className="profile-icon" onClick={toggleDropdown}>
        <span style={{ fontFamily: "Poppins, sans-serif" }} className="profile-initials">
          {firstTwoCharacters}
        </span>
      </div>

      {/* Dropdown Content */}
      {isOpen && (
        <div className="profile-popup" ref={dropdownRef}>
          <div className="header">
            <h4 style={{ opacity: 1, fontFamily: "Poppins, sans-serif" }}>
              {organizationName ?? "Comply Exchange Limited"}
            </h4>
            <div>
              <ExitToAppIcon style={{ color: "#f2ae33", marginRight: 5 }} />
              <span
                onClick={handleLogout}
                style={{ fontFamily: "Poppins, sans-serif" }}
                className="sign-out"
              >
                Logout
              </span>
            </div>
          </div>

          {/* User Details */}
          <div className="user-details">
            <div style={{ fontFamily: "Poppins, sans-serif" }} className="avatar">
              {firstTwoCharacters}
            </div>
            <div>
              <h3 style={{ fontFamily: "Poppins, sans-serif" }}>{userName}</h3>
              <p style={{ fontFamily: "Poppins, sans-serif" }}>{userEmail}</p>
              <div>
                <span
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    padding: 0,
                    margin: 0,
                    fontSize: 13,
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={openResetPopup}
                  className="change-password"
                >
                  Change password
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Reset Password Popup */}
      {showResetPopup && (
        <AdminUpdatePasswordModal
          show={showResetPopup}
          handleClose={closeResetPopup}
          onSave={handleSavePassword}
          editingData={editingData}
        />
      )}
    </div>
  );
};

export default ProfileDropdown;
